import { Alert, AlertType, AlertInterval, AlertClickFn } from "./types";
import Alerts from "./Alerts";

export default Alerts;
export { type Alert, type AlertType, type AlertInterval, type AlertClickFn };
